/**
 * cs-cart-badges.js
 * Injects % Off badges into mini-cart items.
 * Handles both Liquid-rendered compare prices and a fetch fallback
 * for variants where Liquid compare_at_price returns 0.
 */
(function () {
  'use strict';

  var _productCache = {};

  function formatMoney(paise) {
    return '₹' + (paise / 100).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }

  function parsePrice(text) {
    return parseFloat((text || '').replace(/[^\d.]/g, '')) || 0;
  }

  /* ── Badge injection (reads Liquid-rendered price pair) ── */
  function injectBadges() {
    document.querySelectorAll('.xo-cart-mini-item').forEach(function (item) {
      var finalEl   = item.querySelector('.xo-cart-mini-item__final-price');
      var oldEl     = item.querySelector('.xo-cart-mini-item__original-price--old');
      var badge     = item.querySelector('.cs-item-off-badge');
      var wrapper   = item.querySelector('.xo-cart-mini-item__price');

      if (!finalEl || !oldEl) {
        if (badge) badge.remove();
        return;
      }

      var lower  = parsePrice(finalEl.textContent);
      var higher = parsePrice(oldEl.textContent);

      if (higher <= 0 || lower >= higher) {
        if (badge) badge.remove();
        return;
      }

      var pct = Math.round((higher - lower) / higher * 100);
      if (pct <= 0) { if (badge) badge.remove(); return; }

      if (badge) {
        badge.textContent = pct + '% Off';
        return;
      }

      if (!wrapper) return;
      var el = document.createElement('span');
      el.className   = 'cs-item-off-badge';
      el.textContent = pct + '% Off';
      wrapper.insertAdjacentElement('beforeend', el);
    });
  }

  /* ── Fetch fallback for items where Liquid rendered no compare price ── */
  function fetchAndInjectComparePrices() {
    document.querySelectorAll('.xo-cart-mini-item').forEach(function (item) {
      if (item.querySelector('.xo-cart-mini-item__original-price--old')) return;
      if (item.getAttribute('data-cs-fetched')) return;

      var handle    = item.getAttribute('data-product-handle');
      var variantId = parseInt(item.getAttribute('data-variant-id'), 10);
      if (!handle || !variantId) return;

      item.setAttribute('data-cs-fetched', '1');

      function processProduct(product) {
        var variant = null;
        for (var i = 0; i < product.variants.length; i++) {
          if (product.variants[i].id === variantId) { variant = product.variants[i]; break; }
        }
        if (!variant || !variant.compare_at_price || variant.compare_at_price <= variant.price) return;

        var wrapper = item.querySelector('.xo-cart-mini-item__price');
        if (!wrapper) return;

        var plainEl = wrapper.querySelector('.xo-cart-mini-item__original-price:not(.xo-cart-mini-item__original-price--old)');
        if (!plainEl) return;

        wrapper.innerHTML =
          '<div class="xo-cart-mini-item__discounted-prices">' +
            '<span class="xo-cart-mini-item__final-price">' + plainEl.textContent.trim() + '</span>' +
            '<s class="xo-cart-mini-item__original-price xo-cart-mini-item__original-price--old">' + formatMoney(variant.compare_at_price) + '</s>' +
          '</div>';

        injectBadges();
      }

      if (_productCache[handle]) {
        processProduct(_productCache[handle]);
      } else {
        fetch('/products/' + handle + '.js')
          .then(function (r) { return r.json(); })
          .then(function (product) { _productCache[handle] = product; processProduct(product); })
          .catch(function () {});
      }
    });
  }

  function clearFetchedMarkers() {
    document.querySelectorAll('.xo-cart-mini-item[data-cs-fetched]').forEach(function (el) {
      el.removeAttribute('data-cs-fetched');
    });
  }

  var _debounceTimer = null;
  function runAll() {
    clearTimeout(_debounceTimer);
    _debounceTimer = setTimeout(function () {
      clearFetchedMarkers();
      injectBadges();
      fetchAndInjectComparePrices();
    }, 30);
  }

  /* ── Wishlist page badge injection ── */
  function injectWishlistBadges() {
    document.querySelectorAll('.wishlist-table td[data-th="Price"] .xo-price__sale').forEach(function (saleEl) {
      var salePrice = saleEl.querySelector('.xo-price__item--accent, .xo-price__item:not(.xo-price__item--del)');
      var delPrice  = saleEl.querySelector('.xo-price__item--del');
      if (!salePrice || !delPrice) return;
      if (saleEl.querySelector('.cs-item-off-badge')) return;

      var lower  = parsePrice(salePrice.textContent);
      var higher = parsePrice(delPrice.textContent);
      if (higher <= 0 || lower >= higher) return;

      var pct = Math.round((higher - lower) / higher * 100);
      if (pct <= 0) return;

      var el = document.createElement('span');
      el.className   = 'cs-item-off-badge';
      el.textContent = pct + '% Off';
      saleEl.insertAdjacentElement('beforeend', el);
    });
  }

  function bootWishlist() {
    var table = document.querySelector('.wishlist-table');
    if (!table) return;
    injectWishlistBadges();
    new MutationObserver(function () {
      injectWishlistBadges();
    }).observe(table, { childList: true, subtree: true });
  }

  function boot() {
    runAll();
    bootWishlist();

    /* Cart content mutation — fixed selector (element uses xo-unique-id, not id) */
    var cartContent = document.querySelector('[xo-unique-id="xo-cart-mini-content"]');
    if (cartContent) {
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var nodes = mutations[i].addedNodes;
          for (var j = 0; j < nodes.length; j++) {
            if (nodes[j].nodeType === 1 && !nodes[j].classList.contains('cs-item-off-badge')) {
              runAll();
              return;
            }
          }
        }
      }).observe(cartContent, { childList: true, subtree: true });
    }

    /* Mini cart modal open — watch for attribute changes on xo-modal */
    var modal = document.querySelector('xo-modal[xo-name="cart"]');
    if (modal) {
      new MutationObserver(runAll).observe(modal, { attributes: true });
    }

    /* Cart updated event */
    document.addEventListener('xo-cart-updated', runAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();
